import TopNav from './TopNav';

export default function AppShell({ children }) {
  return (
    <div className="appShell noSidebarShell">
      <div className="mainShell">
        <TopNav />
        <main className="pageContent">
          {children}
        </main>
      </div>
    </div>
  );
}